/** The seven registers under Product settings, in the design's tab order (screens/master-data.html). */
export const REGISTERS = [
    'categories',
    'brands',
    'colours',
    'colour-groups',
    'sizes',
    'sale-sources',
    'commodity-codes',
] as const;
export type RegisterKey = (typeof REGISTERS)[number];
